var _path, _rect, _rect2, _rect3, _rect4, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    d: "M378.08,212.88H261.84A30.93,30.93,0,0,0,231,243.77v72.12L180.33,266a11.31,11.31,0,0,0-15.88,0L83,346.34A11.31,11.31,0,0,0,90.9,365.7h13v99.64A16.16,16.16,0,0,0,120,481.48H392.83A16.15,16.15,0,0,0,409,465.34V243.77A30.92,30.92,0,0,0,378.08,212.88ZM231,464.48H197.73V431.07a9.55,9.55,0,0,0-9.55-9.54H163.67a9.54,9.54,0,0,0-9.54,9.54v33.41H120.9V365.7H231Zm161,0h-50.2V431.07a9.55,9.55,0,0,0-9.55-9.54h-24.5a9.54,9.54,0,0,0-9.55,9.54v33.41H248V243.77a13.9,13.9,0,0,1,13.89-13.89H378.08A13.9,13.9,0,0,1,392,243.77Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 42.75,
    rx: 4.87,
    width: 32.95,
    x: 276.22,
    y: 262.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 42.75,
    rx: 4.87,
    width: 32.95,
    x: 330.74,
    y: 262.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 42.75,
    rx: 4.87,
    width: 32.95,
    x: 276.22,
    y: 322.95
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 42.75,
    rx: 4.87,
    width: 32.95,
    x: 330.74,
    y: 322.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M249.06,178.15c.94,0,18.73,0,21.28-.15,30.11-1.34,53.63-10.61,70-27.6,24-24.85,26.06-59.73,25.18-78.31a23.87,23.87,0,0,0-22.8-22.8c-18.59-.88-53.46,1.21-78.31,25.17a78.83,78.83,0,0,0-7.2,8,78.83,78.83,0,0,0-7.2-8c-24.85-24-59.73-26-78.31-25.17a23.87,23.87,0,0,0-22.8,22.8c-.88,18.58,1.21,53.45,25.17,78.31C191.36,168.32,216.56,177.64,249.06,178.15Zm27.85-90.73c17.7-17.06,42.68-20.29,59.06-20.29,2.12,0,4.1.05,5.9.14A6,6,0,0,1,347.55,73c.74,15.68-.88,45-20.16,65-11.71,12.15-28.58,19.36-50.21,21.54a24.66,24.66,0,0,0,.6-5.13c.23-21.48-3.23-39.92-10.31-55.16A61.45,61.45,0,0,1,276.91,87.42ZM166.89,73a6,6,0,0,1,5.68-5.68c15.67-.75,45,.88,65,20.15,13.5,13,20.9,32.35,22.08,57.53a67.86,67.86,0,0,0-32.15-25.2l-5.55,16.78c.86.3,17.55,6.18,26.06,23.59-26.82-.66-47.33-8.12-60.92-22.21C167.77,117.92,166.14,88.63,166.89,73Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEsg);
export default __webpack_public_path__ + "static/media/ico-esg.1c9021d1.svg";
export { ForwardRef as ReactComponent };